import React from "react";
import "./MarketResearch.css";

const MarketResearch = () => {
  return (
    <div>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
      <p>this is MarketResearch</p>
    </div>
  );
};

export default MarketResearch;
